import { Injectable, inject } from "@angular/core";
import { ResponseWrapper } from "@app/integrations/urm/models/response-wrapper";
import { JobFile } from "@app/integrations/urm/models/job-file";
import { HttpClient } from "@angular/common/http";
import { ClientConfigService } from "@app/core/config/client-config.service";

@Injectable({
  providedIn: "root"
})
export class JobService {
  private clientConfigService = inject(ClientConfigService);
  private http = inject(HttpClient);

  private static PATHS = {
    GetJobById:
      "/Services/UniclassRIA-Web-Services-Jobs-Details.svc/JSON/GetJobFileByID"
  };

  async loadJobById(id: string): Promise<JobFile> {
    const config = await this.clientConfigService.config;
    if (config.urmServices.simulate) {
      return this.simulateJobFile(id);
    }
    return new Promise<JobFile>((resolve, reject) => {
      const options = { params: { jobID: id } };
      this.http
        .get(
          config.urmServices.serviceUrl + JobService.PATHS.GetJobById,
          options
        )
        .subscribe(
          (value: any) => {
            let resultWrapper =
              value.GetJobFileByIDResult as ResponseWrapper<JobFile>;
            if (resultWrapper.RootResults.length === 0) {
              reject("Job Record not found.");
            } else if (resultWrapper.RootResults.length > 1) {
              reject("Critical Error: Multiple jobs matched this ID.");
            }
            resolve(resultWrapper.RootResults[0]);
          },
          (error1) => {
            reject(error1);
          }
        );
    });
  }

  private simulateJobFile(id: string): Promise<JobFile> {
    const job = new JobFile();
    job.Jobf_JobIdentity = Math.abs(this.hashCode(id));
    job.Jobf_JobId = id;
    job.Jobf_JobDescription =
      "Repair leaking kitchen tap and check under-sink pipework for corrosion. Tenant reports intermittent drip from hot water side.";
    job.Jobf_CallersName = "Mrs J. Patterson";
    job.Jobf_CallersPhoneNo = "01onal 555 2847";
    job.Jobf_CallersWorkPhoneNo = "";
    job.Jobf_CallersMobileNo = "07700 900123";
    return Promise.resolve(job);
  }

  private hashCode(s: string): number {
    let hash = 0;
    for (let i = 0; i < s.length; i++) {
      hash = (Math.imul(31, hash) + s.charCodeAt(i)) | 0;
    }
    return hash;
  }
}
